import { render } from "./Plank.vue?vue&type=template&id=ee1a247e&scoped=true&ts=true"
import script from "./Plank.vue?vue&type=script&lang=ts"
export * from "./Plank.vue?vue&type=script&lang=ts"

import "./Plank.vue?vue&type=style&index=0&id=ee1a247e&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee1a247e"]])

export default __exports__